import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPkgPrices } from '../paymentsService'
import { PkgPricesResponse } from '../types/PkgPricesResponse'

export const usePkgPrices = (pkgId: string | undefined) => {
  return useQuery<PkgPricesResponse>({
    queryKey: [QUERY_KEYS.PACKAGE, 'prices', pkgId],
    queryFn: () => getPkgPrices(pkgId!),
    enabled: !!pkgId,
  })
}
